import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '../../_modules/error/error_boundary';
import CatalogConfiguratorStore from '../../_flux/stores/catalog_configurator_store';
import HttpRequestStore from '../../_flux/stores/http_request_store';
import { getCatalogFilterOptionsStoreByProductType } from '../../_flux/stores/catalog_filter_options_store/factory';
import { types as productTypes } from '../../_constants/product/types';
import { FilterAvailableOptionsStore } from '../../_flux/stores/filter_available_options_store';
import TyreSizeConfiguratorFilterOptionsStore from '../../_flux/stores/configurator_filter_options_store/tyre';
import TyreMotoSizeConfiguratorFilterOptionsStore from '../../_flux/stores/configurator_filter_options_store/tyre_moto';
import {
    hideTyreIndexLinkAction,
    showSecondLayerAction,
    showInfoLayerAction,
    setPostSuggestionCatalogConfigurator,
    onCatalogPostcodeInputLeave,
    
} from '../../_flux/actions/catalog_configurator_actions';
import { onConfiguratorClose } from './on_configurator_close';
import { onBackClick } from './on_back_click';
import { onShowInfoClick } from './on_show_info';
import { onConfiguratorValueChangeFactory } from './on_configurator_value_change_factory';
import { onConfiguratorSubmitFactory } from './on_configurator_submit_factory';
import { types } from '../../_constants/product/types';
import { handleView } from '../handle_view';
import { isConfiguratorMotoTyreEnabled } from '../configurator/common';

const CatalogConfiguratorComponent = React.lazy(() => import('../../_flux/components/catalog_configurator/catalog_configurator'));
const render = (states, options) => (
    <ErrorBoundary>
        <Suspense fallback={<div>Loading...</div>}>
            <CatalogConfiguratorComponent
                staticUrl={TYROOLA.globals.staticImagesUrl}
                state={states.state}
                options={states.filterOptions}
                countryStore={TYROOLA.globals.store}
                availableOptions={states.availableOptions}
                onClose={onConfiguratorClose}
                onShowSecondLayerClick={showSecondLayerAction}
                onChange={options.onConfiguratorValueChange}
                onSubmit={options.onConfiguratorSubmit(states.state.configuratorType)}
                onInfoClick={onShowInfoClick}
                onBackClick={onBackClick}
                onHideTyreIndexLinkClick={hideTyreIndexLinkAction}
                groupDimensionOptions={options.tyreType !== types.TYRE_MOTO}
                configuratorMotoTyreEnabled={isConfiguratorMotoTyreEnabled()}
                httpRequestState={states.httpRequestState}
                selectPostcodeSuggestion={setPostSuggestionCatalogConfigurator}
                onBlur={onInputLeave}
            />
        </Suspense>
    </ErrorBoundary>
);

const onInputLeave = () => {
    onCatalogPostcodeInputLeave(CatalogConfiguratorStore.getState().values.postcode, CatalogConfiguratorStore.getState().configuratorType);
}

const stores = {
    state: CatalogConfiguratorStore,
    filterOptions: getCatalogFilterOptionsStoreByProductType(productTypes.TYRE_CAR),
    availableOptions: FilterAvailableOptionsStore,
    tyreSizeFilterOptions: TyreSizeConfiguratorFilterOptionsStore,
    motoTyreSizeFilterOptions: TyreMotoSizeConfiguratorFilterOptionsStore,
    httpRequestState: HttpRequestStore,
};

const getOptions = options => ({
    ...options,
    onConfiguratorValueChange: onConfiguratorValueChangeFactory(options.productType),
    onConfiguratorSubmit: onConfiguratorSubmitFactory,
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);
